import { AuditLogTab } from "@/components/settings/AuditLogTab";

export function SettingsAuditPage() {
  return <AuditLogTab />;
}
